// styles.ts
import { CSSObject } from "styled-components";
import { vfxTheme } from "../Theme/theme";

interface DrawerStyles {
    drawerContainer: CSSObject;
    drawer: CSSObject;
    drawerContainerOpen: CSSObject;
    drawerHeader: CSSObject;
    drawerContent: CSSObject;
}

const useDrawerStyles = (): DrawerStyles => {
    

    return {
        drawerContainer: {
            position: "fixed",
            top: "0",
            right: "0",
            width: "0",
            height: "100%",
            overflow: "hidden",
            display: "flex",
            justifyContent: "flex-end",
            transition: "width 0.3s",
            zIndex: vfxTheme.drawer.zIndex,
        },
        drawer: {
            height: "100%",
            background: vfxTheme.palette.white,
            padding: `${vfxTheme.spaceUnits.sp01 * 4}px`,
            display: "flex",
            flexDirection: "column",
            transition: "width 0.3s",
            boxShadow:
                "0px 1px 4px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.02), 0px 1px 12px rgba(0, 0, 0, 0.12)",
        },
        drawerHeader: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: `${vfxTheme.spaceUnits.sp01 * 4}px`,
        },
        drawerContent: {
            flexGrow: "1",
            overflowY: "auto",
            overflowX: "hidden",
        },
        drawerContainerOpen: {
            position: "fixed",
            top: "0",
            right: "0",
            height: "100%",
            overflow: "hidden",
            display: "flex",
            justifyContent: "flex-end",
            transition: "width 0.3s",
            zIndex: vfxTheme.drawer.zIndex,
            width: "100%",
        },
    };
};
export default useDrawerStyles;
